import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { styles } from '../../styles/details-panel-styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import LogTable from '../LogTable';
import StatsTable from '../StatsTable';
import { buildChartCard } from '../ChartCard/utils';
import { buildChartCards } from '../ChartPanel/utils';

const DetailsPanel = (props) => {
  const { classes, ...other } = props;
  const dataMap = props.data.find(map => {
    return map.monitor.id === props.detailsMonitorId;
  })
  const panelProps = {...other};
  return (
      <Grid container spacing={16} classes={{container: classes.root}}>
        <Grid container spacing={16} alignItems="stretch">
          {buildChartCards(8, props, [dataMap])[0].element}
          <Grid item xs={4}>
            <StatsTable data={dataMap.monitor.responseTimes} />
          </Grid> 
        </Grid>

        {dataMap.monitor.type === "response"
          ?
            <Grid container spacing={16} classes={{container: classes.detailsGrid}}>
              <Grid item xs={12}>
                  <LogTable data={dataMap.monitor.logs} />
                </Grid>  
            </Grid>         
          : null
        }
      </Grid>
  )
}
  
DetailsPanel.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DetailsPanel);


// WEBPACK FOOTER //
// ./src/components/Details/DetailsPanel.js